import { browserHistory } from 'react-router';
import { getLinkLocation, getQualifiedUrl } from 'qualified-location';

export const LOCATION_CHANGED = 'LOCATION_CHANGED';
export const TRACKED_LINK_CLICKED = 'TRACKED_LINK_CLICKED';
export const CAMPAIGN_LINK_CLICKED = 'CAMPAIGN_LINK_CLICKED';
const LOCALE_CHANGED = 'LOCALE_CHANGED';

const initialState = {
  url: null,
  locale: 'AU',
  pathname: null,
  query: null,
  pageNumber: null,
  isHomepage: true
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LOCATION_CHANGED: {
      const { url, location } = action.payload;
      const { pathname, query } = location;

      return {
        ...state,
        url,
        pathname,
        query,
        pageNumber: parseInt(query.page || '1', 10),
        isHomepage: pathname === '/'
      };
    }

    case LOCALE_CHANGED: {
      const locale = action.payload;

      return {
        ...state,
        locale
      };
    }

    default:
      return state;
  }
}

export function locationChanged(url, location) {
  return {
    type: LOCATION_CHANGED,
    payload: {
      url,
      location
    },
    meta: {
      metrics: {
        name: LOCATION_CHANGED
      }
    }
  };
}

export function localeChanged(locale) {
  return {
    type: LOCALE_CHANGED,
    payload: locale
  };
}

export function trackedLinkClicked(link) {
  return {
    type: TRACKED_LINK_CLICKED,
    payload: link
  };
}

export function campaignLinkClicked(link) {
  return {
    type: CAMPAIGN_LINK_CLICKED,
    payload: link,
    meta: {
      hotjar: 'Campaign Link Clicked',
      metrics: {
        name: CAMPAIGN_LINK_CLICKED
      }
    }

  };
}

export function navigate({
    analytics,
    params,
    path,
    preNavigationAction,
    state
  }) {
  return (dispatch, getState) => {
    // get qualified link
    const qualifiedUrl = getQualifiedUrl(getState().location, path, params);

    // send off tracking analytics
    if (analytics) {
      const href = `${window.location.hostname}${qualifiedUrl.path}`;
      dispatch(trackedLinkClicked({ href, analytics }));
    }

    // merge state into qualified link location
    const location = getLinkLocation({ qualifiedUrl, state });

    // Run prenavigation
    const prenav = preNavigationAction && dispatch(preNavigationAction());
    return Promise
      .resolve(prenav)
      .then(() => {
        browserHistory.push(location);
      });
  };
}



/** WEBPACK FOOTER **
 ** ./app/store/location/location.js
 **/